import { Alert as MantineAlert } from "@mantine/core";

export const Alert = MantineAlert;
